// Secure only on https: on http://192.168.x.x (LAN testing) the browser
// refuses Secure cookies. On the live SSL site it is always Secure.
const secure = () =>
  window.location.protocol === "https:" ? "; Secure" : "";

export const setCookie = (name, value, days = 15) => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(
    JSON.stringify(value),
  )}; expires=${expires}; path=/; SameSite=Strict${secure()}`;
};

export const getCookie = (name) => {
  const row = document.cookie.split("; ").find((c) => c.startsWith(`${name}=`));
  if (!row) return null;
  try {
    return JSON.parse(decodeURIComponent(row.slice(name.length + 1)));
  } catch {
    return null;
  }
};

export const removeCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Strict${secure()}`;
};

export const clearAllCookies = () => {
  document.cookie
    .split("; ")
    .filter(Boolean)
    .forEach((c) => removeCookie(c.split("=")[0]));
};
